import { useEffect, useState } from "react";

export default function useOnlineStatus(wsOnline) {
  const deriveOnline = () => {
    const browserOnline =
      typeof navigator !== "undefined" ? navigator.onLine : true;
    if (typeof wsOnline === "boolean") return wsOnline && browserOnline;
    if (typeof wsOnline === "number") return wsOnline === 1 && browserOnline; // WebSocket.OPEN === 1
    return browserOnline;
  };

  const [isOnline, setIsOnline] = useState(deriveOnline);

  useEffect(() => {
    const handleOnline = () => setIsOnline(deriveOnline());
    const handleOffline = () => setIsOnline(deriveOnline());

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // update when wsOnline changes as well
    setIsOnline(deriveOnline());

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [wsOnline]);

  return isOnline;
}
